import classes from './Form.module.scss' ;
import useInput from '../../Hooks/Use-Input';
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import {Container , Row , Col  } from 'react-bootstrap' 
import {range} from '../../Utility/Consts' ;
import { GrFormNextLink } from "react-icons/gr";
import { useNavigate } from 'react-router-dom';
//--------------------------------


const   Form = ({lang , page , path}) => {
    const content = {
        en: {
            title: 'Contact us now.',
            cusName : {1:'Name' , 2:'Your  Name' ,3:'Your name must not be empty'},
            cusCompanyName :{1:'Company Name',2:'Your Company Name',3:'Company Name must not be empty'},
            cusTitle : {1:'Title',2:'Your Title',3:'Title must not be empty'},
            cusPhoneNumber : {1:'Phone Number',2:'Your Phone Number',3:'The Phone Number must not be empty'},
            cusMailAddress : {1:'E-Mail Address',2:'Your Email Address',3:'please enter a valid email'},
            cusCountryName : {1:"Country Name",2:'',3:'Country Name must not be empty'},
            buttonAction : "Submit",
            message :'Thanks , We Will Contact You As Soon As Possible',
        },
        ar: {
            title: 'تواصل معنا',
            cusName : {1:'الإسم',2:'إسمك',3:'برجاء تسجيل الإسم'},
            cusCompanyName :{1:'إسم الشركة',2:'إسم شركتك',3:'برجاء تسجيل إسم الشركة'},
            cusTitle : {1:'المسمى الوظيفى',2:'المسمى الوظيفى الخاص بك',3:'برجاء تسجيل المسمى الوظيفى الخاص بك'},
            cusPhoneNumber : {1:'رقم الهاتف',2:'رقم هاتفك',3:'برجاء إدخال رقم الهاتف'},
            cusMailAddress : {1:'البريد الإلكترونى',2:'عنوان بريدك الإلكترونى',3:'برجاء إدخال البريد الإلكترونى'},
            cusCountryName : {1:"إسم الدولة",2:'',3:'برجاء إختيار إسم الدولة'},
            buttonAction : "إرسال",
            message :'شكرًا لك، سنتواصل معك في أقرب وقت ممكن',
        }
    };
    //=======================================================
    const formRef = useRef();
    const phoneEx = /\d{11}/
    //-----------------------------------------------------------------------
    const {value : enteredName ,hasError : nameInputIsInvalid , valueIsValid : enteredNameIsValid ,
        valueChangeHandler : nameInputChangeHandler , inputBlurHandler : nameInputBlurHandler , reset : resetNameInput} = useInput(value => value.trim() !=='') ;
    const {value : companyName ,hasError : companyNameIsInvalid , valueIsValid : companyNameIsValid ,
        valueChangeHandler : companyNameInputChangeHandler , inputBlurHandler : companyNameInputBlurHandler , reset : resetCompanyName} = useInput(value => value.trim() !=='') ;
    const {value : titleName ,hasError : titleNameIsInvalid , valueIsValid : titleNameIsValid ,
        valueChangeHandler : titleNameInputChangeHandler , inputBlurHandler : titleNameInputBlurHandler , reset : resetTitleName} = useInput(value => value.trim() !=='') ;
    const {value : phoneNumber ,hasError : phoneNumberIsInvalid , valueIsValid : phoneNumberIsValid ,
        valueChangeHandler : phoneNumberInputChangeHandler , inputBlurHandler : phoneNumberInputBlurHandler , reset : resetPhoneNumber} = useInput(value => value.trim() !=='' && phoneEx.test(value)) ;
    const {value : enteredEmail ,hasError : emailInputIsInvalid , valueIsValid : enteredEmailIsValid ,
        valueChangeHandler : emailInputChangeHandler , inputBlurHandler : emailInputBlurHandler , reset : resetEmailInput} = useInput(value => value.includes('@')) ;
    //--------------------------------------------------
    const {value : enteredCon ,hasError : conInputIsInvalid , valueIsValid : enteredConIsValid,
        valueChangeHandler : conInputChangeHandler , inputBlurHandler : conInputBlurHandler, reset : resetConInput} = useInput(value => value.trim() !=='' && value.trim() !== '--Please Choose An Option--') ;
    //=======================================================
    let formIsValid = false
    if(enteredNameIsValid &&companyNameIsValid && titleNameIsValid && phoneNumberIsValid && enteredEmailIsValid  && 
    enteredConIsValid){
    formIsValid = true;
    }
    //=======================================================
    const navigate = useNavigate();
    const handleSubmit = (e) => {
        e.preventDefault();
        if(!formIsValid){
            return;
        } ;
        emailjs.sendForm(
            'service_b56egkk',
            // 'template_ucdwaig',
            // order ?  'template_ucdwaig':'template_e0cntld',
            'template_ucdwaig',
            formRef.current,
            '_x7rh3jMyIeDEdNTe').then(
            (result) => {
                // console.log(result.text);
                // setMessage(true);
                //navigate
                navigate(path)
            },
            (error) => {
                console.log(error.text);
            });
    
        e.target.reset();
        resetNameInput() ;
        resetEmailInput() ;
        resetCompanyName() ;
        resetTitleName();
        resetPhoneNumber();
        resetConInput();
        // resetChannelInput();
        // resetProInput();
        // resetMsg() 
        ;};
    //--------------------------------------------------
    const nameInputClasses = nameInputIsInvalid? `${classes["form-control"]} ${classes.invalid}` : `${classes["form-control"]}` ;
    const companyNameInputClasses = companyNameIsInvalid? `${classes["form-control"]} ${classes.invalid}` : `${classes["form-control"]}` ;
    const titleNameInputClasses = titleNameIsInvalid? `${classes["form-control"]} ${classes.invalid}` : `${classes["form-control"]}` ;
    const phoneNumberInputClasses = phoneNumberIsInvalid? `${classes["form-control"]} ${classes.invalid}` : `${classes["form-control"]}` ;
    const emailInputClasses = emailInputIsInvalid? `${classes["form-control"]} ${classes.invalid}` : `${classes["form-control"]}` ;
    const ConClasses = conInputIsInvalid? `${classes["form-control"]} ${classes.invalid}` : `${classes["form-control"]}` ;
    //----------------------------------------------------------
    let sourcePge = '';
    if(page === 'landing'){
        sourcePge = 'LANDING_EN';
    }else if(page === 'ar-pacs-ris'){
        sourcePge = 'LANDING_AR_PACS_RIS';
    }else if(page === 'ar-polyclinic-erp'){
        sourcePge = 'LANDING_AR_POLYCLINIC_ERP';
    }else{
        sourcePge = '';
    }
    //----------------------------------------------------------

    return(
        <Container >
            <section className={`${classes.secpro} w-100`}>
                <h1 className={`${lang === 'ar'&&classes.ar_text}`} >{content[lang].title}</h1>
                <Row md={2} xs={1} lg={3} className={`g-5 p-md-3 gap-5  justify-content-center w-100`}>
                    <Col  className={`${classes["contact-col"]} flex-fill`}>
                        <form ref={formRef} onSubmit={handleSubmit}>
                            {/* ----------------------sourcePge ------------------------------ */}
                            <input type="text" name='Page' hidden value={sourcePge}/>
                            {/* ----------------------sourcePge ------------------------------ */}
                            <Col className={`d-flex flex-column justify-content-center  p-lg-4 align-items-center`}>
                                <Row md={2} xs={1} lg={2} className={`w-100`}>
                                    <Col className={`${nameInputClasses} ${lang === 'ar'&&classes.ar_text} d-flex flex-column align-items-start`} >
                                        <label htmlFor='f-name'>{content[lang].cusName[1]}</label>
                                        <input type='text' id='f-name' name="Name" placeholder={content[lang].cusName[2]} required
                                        onChange={nameInputChangeHandler} value={enteredName} onBlur={nameInputBlurHandler} />
                                        {nameInputIsInvalid && <p className={`${classes['error-text']} ${lang === 'ar'&&classes.ar_text}`}>{content[lang].cusName[3]}</p>}
                                    </Col>
                                    <Col className={`${companyNameInputClasses} ${lang === 'ar'&&classes.ar_text} d-flex flex-column align-items-start`}>
                                        <label htmlFor='company-name'>{content[lang].cusCompanyName[1]}</label>
                                        <input type='text' id='company-name'  name="Company Name" placeholder={content[lang].cusCompanyName[2]}required 
                                        onChange={companyNameInputChangeHandler} value={companyName} onBlur={companyNameInputBlurHandler} />
                                        {companyNameIsInvalid && <p className={`${classes['error-text']} ${lang === 'ar'&&classes.ar_text}`}>{content[lang].cusCompanyName[3]}</p>}
                                    </Col>
                                </Row>
                                <Row md={2} xs={1} lg={2} className={`w-100`}>
                                    <Col className={`${titleNameInputClasses} ${lang === 'ar'&&classes.ar_text}  d-flex flex-column align-items-start`}>
                                        <label htmlFor='title-name'>{content[lang].cusTitle[1]}</label>
                                        <input type='text' id='title-name'  name="Title Name" placeholder={content[lang].cusTitle[2]} required 
                                        onChange={titleNameInputChangeHandler} value={titleName} onBlur={titleNameInputBlurHandler} />
                                        {titleNameIsInvalid && <p className={`${classes['error-text']} ${lang === 'ar'&&classes.ar_text}`}>{content[lang].cusTitle[3]}</p>}
                                    </Col>
                                    <Col className={`${phoneNumberInputClasses} ${lang === 'ar'&&classes.ar_text} d-flex flex-column align-items-start`}>
                                        <label htmlFor='Phone-number'>{content[lang].cusPhoneNumber[1]}</label>
                                        <input type='text' id='Phone-number'  name="Phone Number" placeholder={content[lang].cusPhoneNumber[2]} required 
                                        onChange={phoneNumberInputChangeHandler} value={phoneNumber} onBlur={phoneNumberInputBlurHandler} />
                                        {phoneNumberIsInvalid && <p className={`${classes['error-text']} ${lang === 'ar'&&classes.ar_text}`}>{content[lang].cusPhoneNumber[3]}</p>}
                                    </Col>
                                </Row>
                                <Row md={2} xs={1} lg={2} className={`w-100`}>
                                    <Col className={`${emailInputClasses} ${lang === 'ar'&&classes.ar_text} d-flex flex-column align-items-start`}>
                                            <label htmlFor='email'>{content[lang].cusMailAddress[1]}</label>
                                            <input type='email' id='email' name="Email Address" placeholder={content[lang].cusMailAddress[2]} required
                                            onChange={emailInputChangeHandler} value={enteredEmail} onBlur={emailInputBlurHandler}/>
                                            {emailInputIsInvalid && <p className={`${classes['error-text']} ${lang === 'ar'&&classes.ar_text}`}>{content[lang].cusMailAddress[3]}</p>}
                                    </Col>
                                    {/* ==================================================== */}
                                    <Col className={`${ConClasses} ${lang === 'ar'&&classes.ar_text} d-flex flex-column align-items-start`}>
                                        <label htmlFor="country" >{content[lang].cusCountryName[1]}</label>
                                        <select  defaultValue={"--Please Choose An Option--"}  id='country' name="country" value={enteredCon} required
                                        onChange={conInputChangeHandler} onBlur={conInputBlurHandler}  className={enteredCon?classes.done:null} dir='ltr'>
                                            {range.map(item => {return <option value={item.name} key={item.code} >{item.name}</option>})}
                                        </select>
                                        {conInputIsInvalid && <p className={`${classes['error-text']} ${lang === 'ar'&&classes.ar_text}`}>{content[lang].cusCountryName[3]}</p>}
                                    </Col>
                                </Row>
                                <Row md={2} xs={1} lg={2} className={`d-flex w-100 justify-end align-items-end`}>
                                    <Col className={`  d-flex flex-column align-items-start`}>
                                        <button className={`${classes["glow-on"]}  ${lang === 'ar'&&classes.ar_text} `} disabled={!formIsValid}>
                                        {content[lang].buttonAction}<GrFormNextLink />
                                        </button>
                                    </Col>
                                    {/* {message && <span className={`text-success mt-3 fst-italic fs-6`}>{content[lang].message}</span>} */}
                                </Row>
                            </Col>
                        </form>
                    </Col>
                </Row>
            </section>
        </Container>
    )
}
export default Form